module.exports = __webpack_public_path__ + "static/media/Lorenzo Villaggi.15f4a059.png";